var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group v-padded"},[_c('h3',{staticClass:"row-title"},[_vm._v(_vm._s(_vm.group.type))]),_vm._l((_vm.group.joinus),function(join,i){return [_c('join',{key:i,attrs:{"join":join}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }